export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7412.d48c7ee9.jpg";